import React from 'react'
import { SvgIcon } from './SvgIcon'

interface Props {
  className?: string
}

export function Github({ className }: Props) {
  return (
    <SvgIcon className={className} viewBox="0 0 30 30" fill="currentColor">
      <path d="M15,0a15,15,0,0,0-3.62,29.54c0-.81,0-1.36,0-1.36,0-1.28,0-2.92,0-3.12,0,0-3.19.91-4.55-1.33a6,6,0,0,0-1.52-2.34s-.73-.38-.8-.72a.22.22,0,0,1,.11-.18c.08,0,1.23-.48,2.51,1.11.39.53,1.27,2.57,4.33,1.31a1.47,1.47,0,0,1,1.22-1.24c-4.56-.53-7.39-2.7-8.1-6.73-.44-2.74,1.18-4,2.35-5.11A5.21,5.21,0,0,1,7.12,5.7c1-.19,2.78.5,4.36,1.61a13.38,13.38,0,0,1,7.39,0c.71-.58,3.25-1.92,4.34-1.61a28.84,28.84,0,0,1,.14,4.13A6.61,6.61,0,0,1,25.43,15c-.16,3.53-2.46,6.2-7.29,6.61a3.18,3.18,0,0,1,1.31,2.6c0,.28,0,2.51.05,5.07A15,15,0,0,0,15,0Z" />
    </SvgIcon>
  )
}
